<div class="card card-body mb-0">
    <div class="mb-4 h6">Virmani - Menadžerski ugovor</div>
    <div class="row border-bottom pb-3 mb-3">
        <div class="col-12">

            <div class="col-12 col-xl-6 form-group">
                <label class="fw-bold">
                    <span class=""> {{ "PROPERTIES.Obračun" | translate }}</span>
                </label>
                <div class="input-group">
                    <ng-select class="col p-0 form-select" [items]="obracuni" loadingText="Ucitavanje..." [virtualScroll]="true"
                        [selectOnTab]="true" [(ngModel)]="params.autoBr" bindValue="autoBr" bindLabel="nazivObracccuna"
                        (change)="getStavke()" [clearable]="false">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div>{{ item.nazivObracccuna }}</div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>

            <div class="pagination-space">
                <div class="common-fiwe">
                    <div class="recent-table table-responsive custom-scrollbar invoice-table">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>
                                        {{"PROPERTIES.Naziv virmana" | translate}} - {{rowCount}}
                                    </th>

                                    <th>
                                        {{"PROPERTIES.Iznos za uplatu" | translate}}
                                    </th>

                                    <th>
                                        {{"PROPERTIES.Račun primatelja" | translate}}
                                    </th>

                                    <th>
                                        {{"PROPERTIES.Broj poreskog obveznika" | translate}}
                                    </th>

                                    <th>
                                        {{"PROPERTIES.Vrsta prihoda" | translate}}
                                    </th>

                                    <th>
                                        {{"PROPERTIES.Općina" | translate}}
                                    </th>

                                    <th>
                                        {{"PROPERTIES.Budžetska organizacija" | translate}}
                                    </th>

                                    <th>
                                        {{"PROPERTIES.Poziv na broj" | translate}}
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let item of stavke; index as i">
                                    <td role="button">
                                        <p class="c-o-light">{{ item?.nazivVirmana }}</p>
                                    </td>
                                    <td role="button">
                                        <p class="c-o-light">{{ item?.iznos | number : '1.2-2' }}</p>
                                    </td>
                                    <!--  <td role="button">
                                        <p class="c-o-light">{{ item?.primalac }}</p>
                                    </td> -->
                                    <td role="button">
                                        <p class="c-o-light">{{ item?.racccunPrimaoca }}</p>
                                    </td>
                                    <td role="button">
                                        <p class="c-o-light">{{ item?.brojPorObveznika }}</p>
                                    </td>
                                    <td role="button">
                                        <p class="c-o-light">{{ item?.vrstaPrihoda }}</p>
                                    </td>
                                    <td role="button">
                                        <p class="c-o-light">{{ item?.oznakaOpccine }}</p>
                                    </td>
                                    <td role="button">
                                        <p class="c-o-light">{{ item?.budzzetskaOrganizacija }}</p>
                                    </td>
                                    <td role="button">
                                        <p class="c-o-light">{{ item?.pozivNaBroj }}</p>
                                    </td>
                                </tr>
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>
            <div *ngIf="loading" class="loader-box">
                <div class="loader-2"></div>
            </div>

            <div class="d-flex align-items-center justify-content-end mt-4">
                <!-- <button class="btn btn-light me-2" (click)="closeModal()" type="button">
                    {{ "PROPERTIES.Zatvori" | translate }}
                </button> -->

                <ng-select #artikalElement class="col-5 p-0 select-append" (keyup.enter)="$event.stopPropagation()"
                    [items]="downloadTypes" bindLabel="label" bindValue="value" formControlName="artikal"
                    loadingText="Ucitavanje..." (change)="setDownloadType($event)" [virtualScroll]="true"
                    [selectOnTab]="true">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <div class="w-100 d-flex">
                            <span class="w-15 text-wrap"> <i class="fa fa-download me-2"></i></span>
                            <span class="w-85 text-wrap">{{ item.label }}</span>
                        </div>
                    </ng-template>
                </ng-select>

                <button class="btn btn-primary ms-1" type="button" (click)="getNalogZaPlacanje()"
                    [ngbTooltip]="'PROPERTIES.Preuzmi nalog za plaćanje' | translate">
                    <i class="fa fa-download"></i> </button>
            </div>
        </div>
    </div>
</div>